import { render } from "./FilesPanel.vue?vue&type=template&id=5e2f095d&scoped=true"
import script from "./FilesPanel.vue?vue&type=script&lang=js"
export * from "./FilesPanel.vue?vue&type=script&lang=js"

import "./FilesPanel.vue?vue&type=style&index=0&id=5e2f095d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e2f095d"]])

export default __exports__